/* global analytics */
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useLocation, useRouteMatch } from 'react-router'
import queryString from 'qs'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'

import MetaTags from '../../../components/meta/MetaTags'
import SectionIntro from '../../../components/landing/SectionIntro'
import Testimonials from '../../../components/landing/Testimonials'
import { Container } from '../../../components/landing/display'
import ScrollTop from '../../../components/utils/ScrollTop'
import Confidence from './Confidence'
import Header from './Header'
import Help from './Help'
import HowItWorksSteps from './HowItWorksSteps'
import FAQ from './FAQ'
import Video from './Video'
import WhyBecomeAHost from './WhyBecomeAHost'
import MarketAlert from './MarketAlert'
import { CTAAnnotation, GetStartedCTA } from './CTAs'
import testimonials from './testimonials'

const WithModerateTopMargin = styled.div`
  margin-top: 60px;
`

const Onboarding = () => {
  const match = useRouteMatch()
  const location = useLocation()
  const market = queryString.parse(location.search, { ignoreQueryPrefix: true })
    .market

  const isInvited = !!match.path.match(/^\/onboarding/)

  const { md: largerThanMd } = useMediaQueryContext()
  const smallerThanMd = !largerThanMd

  useEffect(() => {
    analytics.track('Onboarding Landing Page Viewed')
  }, [])

  const whyBecomeAHostTitle = 'Why Become a Riparide Host'

  const whyBecomeAHostDetail =
    'Every property is unique, and we want people to experience the magic of yours.'

  return (
    <>
      <ScrollTop />
      <MetaTags title="Become a Host" />
      <Header isInvited={isInvited} />

      {/* unset overflow to enable normal magin collapse */}
      <Container style={{ overflow: 'unset' }}>
        <MarketAlert
          marketCode={market?.toString()}
          isInvited={isInvited}
          search={location?.search}
        />

        <SectionIntro
          primaryHeading={whyBecomeAHostTitle}
          paragraphText={whyBecomeAHostDetail}
        />
        <WhyBecomeAHost />
      </Container>

      <Testimonials testimonials={testimonials} />

      <Container>
        <SectionIntro
          primaryHeading="How It Works"
          paragraphText="Joining our Host Community is so simple, you’ll be welcoming guests in no time."
        />
        <HowItWorksSteps isInvited={isInvited} />
        <WithModerateTopMargin>
          <GetStartedCTA
            isInvited={isInvited}
            search={location.search}
            info={<CTAAnnotation>Join our Host Community</CTAAnnotation>}
            noMarginTop
          />
        </WithModerateTopMargin>
      </Container>

      <Container>
        <Video />
      </Container>

      <Container>
        <SectionIntro
          primaryHeading="Be Your Best Host"
          paragraphText="You’ve got the property and we’ve got the tools to help you host with confidence."
        />
        <Confidence />
      </Container>

      <Container>
        {smallerThanMd ? (
          <GetStartedCTA
            isInvited={isInvited}
            search={location.search}
            info={<CTAAnnotation>Ready to join Riparide?</CTAAnnotation>}
            noMarginTop
          />
        ) : (
          <>
            <SectionIntro
              primaryHeading="Ready to Join Riparide?"
              paragraphText="Create your listing today and welcome your first guests."
              reducedMarginBottom
            />
            <GetStartedCTA
              isInvited={isInvited}
              search={location.search}
              noMarginTop
            />
          </>
        )}

        <FAQ />
        <Help />
      </Container>
    </>
  )
}

export default Onboarding
